import React, { useEffect, useState } from "react";
import styles from './trainingPrograms.module.scss';

// import bannerImg1 from "../../../../Assets/images/trainingpage/bannerImg1.png";
// import bannerImg2 from "../../../../Assets/images/trainingpage/bannerImg2.png";
// import axiosClient from "../../../../Utils/Axios/AxiosClient";
import { useSelector } from "react-redux";
import TrainingCard from "../../../../components/TrainingCard/TrainingCard";
import { useFetchAllPartnerTraining } from "../../../../hooks/partnerHook/usePartnerTraining";
import TrainingProgramDetailsModal from "../../../../components/TrainingProgramDetailsModal/TrainingProgramDetailsModal";

function TrainingPrograms() {
  const [trainingData, setTrainingData] = useState([]);
  const [showDetails, setShowDetails] = useState(false);
  const [fullProgramDetails, setFullprogramDetails] = useState(null)
  const { data: trainingPrograms, isPending, isError } = useFetchAllPartnerTraining();

  useEffect(() => {
    if (trainingPrograms) {
      console.log("Training Data:", trainingPrograms);
      setTrainingData(trainingPrograms)
    }
  }, [trainingPrograms])


  if (isPending) {
    return <div>Loading...</div>;
  }

  if (isError) {
    return <div>Error...</div>;
  }

  return (
    <>
      <div className={styles.trainingPrograms}>
        <div className={styles.programHeader}>
          <h1>Courses you can apply</h1>
          <p>Kickstart your business with a template built for Drone Pilots, Photographers etc.</p>
        </div>

        <div className={styles.programBody}>
          {
            trainingPrograms.map((program) =>
              <TrainingCard program={program} setShowDetails={setShowDetails} setFullprogramDetails={setFullprogramDetails} />
            )
          }
        </div>
      </div>
      {
        showDetails && fullProgramDetails &&
        <TrainingProgramDetailsModal setShowDetails={setShowDetails} setFullprogramDetails={setFullprogramDetails} fullProgramDetails={fullProgramDetails} />
      }
    </>
  );
}

export default TrainingPrograms;
